const authenticity = {
  title: () => 'Shop italist | Assurance of Authenticity',
  description: () =>
    'Real. Legit. Not fake. However you want to call it, italist products are guaranteed to be 100% authentic.'
};

export default authenticity;
